import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from 'app/app.component';
import { appConfig } from 'app/app.config';

// Klucz przechowujący timestamp ostatniej próby odświeżenia po błędzie chunku.
const CHUNK_RELOAD_KEY = 'chunk-reload-ts';
// Minimalny odstęp między automatycznymi przeładowaniami — chroni przed pętlą.
const CHUNK_RELOAD_COOLDOWN = 15000;

function isChunkLoadError(err: unknown): boolean {
  const msg = err && (err as { message?: string }).message
    ? String((err as { message?: string }).message)
    : String(err);
  return /ChunkLoadError|Loading chunk [\d]+ failed|Failed to fetch dynamically imported module|error loading dynamically imported module/i.test(msg);
}

/**
 * Gdy bundle/lazy-chunk nie załaduje się (najczęściej przez niespójny cache
 * przeglądarki — stary vendor.js obok świeżego runtime.js), zamiast pustego
 * ekranu robimy jednorazowe przeładowanie. Cooldown blokuje zapętlenie, gdy
 * problem jest trwały.
 */
function reloadOnceForChunkError(err: unknown): void {
  if (!isChunkLoadError(err)) return;
  const last = Number(sessionStorage.getItem(CHUNK_RELOAD_KEY) || 0);
  const now = Date.now();
  if (now - last < CHUNK_RELOAD_COOLDOWN) return;
  sessionStorage.setItem(CHUNK_RELOAD_KEY, String(now));
  window.location.reload();
}

// Lazy-route chunki padają asynchronicznie — łapiemy je globalnie.
window.addEventListener('error', (e) => reloadOnceForChunkError(e.error || e.message));
window.addEventListener('unhandledrejection', (e) => reloadOnceForChunkError(e.reason));

bootstrapApplication(AppComponent, appConfig)
  .catch(err => {
    console.error(err);
    reloadOnceForChunkError(err);
  });
